import { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export default css`
  .marker-wrapper {
    display: flex;
    flex-direction: column;
    padding: 10px 5px;
  }

  .marker-group {
    width: 100%;
    padding: 0 5px;
  }

  .marker-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
  }

  .marker-type {
    font-weight: ${themeGet('fontWeights.bold')};
    color: ${themeGet('colors.pc-red', '#E1251B')};
    font-size: 16px;
    white-space: nowrap;
    margin-right: 10px;
  }

  .marker-distance {
    font-size: 16px;
  }

  .marker-address {
    font-size: 12px;
    margin-bottom: 10px;
  }

  .marker-hours {
    width: 100%;
    padding: 0 5px;
    ul {
      margin-left: 0;
      li {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }
  }

  .marker-day {
    font-size: 12px;
    font-weight: ${themeGet('fontWeights.bold')};
    width: 15px;
    display: inline-block;
  }

  .marker-time {
    font-size: 12px;
    margin-left: 10px;
    width: 100%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    .marker-wrapper {
      display: flex;
      flex-direction: row;
      padding: 10px 5px;
    }

    .marker-group {
      width: 60%;
      padding: 0 5px;
    }

    .marker-info {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      margin-bottom: 20px;
    }

    .marker-type {
      font-weight: ${themeGet('fontWeights.bold')};
      color: ${themeGet('colors.pc-red', '#E1251B')};
      font-size: 24px;
      margin-right: 20px;
    }

    .marker-distance {
      font-size: 24px;
    }

    .marker-address {
      font-size: 16px;
      margin-bottom: 10px;
    }

    .marker-hours {
      width: 40%;
      padding: 0 5px;
      margin-left: 20px;
      ul {
        li {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      }
    }

    .marker-day {
      font-size: 14px;
      font-weight: ${themeGet('fontWeights.bold')};
      width: 15px;
      display: inline-block;
    }

    .marker-time {
      font-size: 14px;
      margin-left: 20px;
      width: 100%;
    }
  }
`;
